let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iTf1E")).then(() => parcelRequire('7IGR2'));